import React, { useState} from 'react';

const PoligonsFilterConstructionViewing = ({ handlePoligonCantonChange, showPolygonsCanton, handlePoligonAreaChange, showPolygonsArea,
  handleHousesChange, showHouses, handleLineRankSummitToCantonCheckboxChange, showLinesRankSummitToCanton, highwayTerritory, roleId,
  allowedRoles, handleHousesActivatedPassiveChange, showHousesActivatedPassive, handleHousesNoActivChange, showHousesActiv, 
  handleHousesActivChange, showHousesNoActiv}) => {

    

 
  const [isVisibleDiv, setIsVisibleDiv] = useState(false);

  function toggleVisibilityDiv() {
    setIsVisibleDiv(!isVisibleDiv);
  }

    return (
      <React.Fragment>
      <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
        {isVisibleDiv ? 'Территория: скрыть' : 'Территория: показать'}
      </button>

  {isVisibleDiv && ( 
    <div className='equipmentDiv' style={{marginTop: "10px"}}>
      <label className='typeLabelDiv' style={{textShadow: '2px 2px 4px #242424'}}>Территория</label>
      <hr className='horizontalLineDrawer'/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showPolygonsCanton}
          onChange={handlePoligonCantonChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' ,textShadow: '2px 2px 4px #242424'}}>Граници округа</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showPolygonsArea}
          onChange={handlePoligonAreaChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' ,textShadow: '2px 2px 4px #242424'}}>Граници веток</label>
      </div>    
        <br/>
        <label className='typeLabelDiv' style={{textShadow: '2px 2px 4px #242424'}}>Дом</label>  
        <hr className='horizontalLineDrawer'/>  
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={showHouses}
            onChange={handleHousesChange}
            style={{ marginRight: '5px' }}
          />
          <label style={{ marginRight: '10px', color: '#bdbdbd',textShadow: '2px 2px 4px #242424' }}>Все дома</label>
      </div> 

       <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={showHousesNoActiv}
            onChange={handleHousesNoActivChange}
            style={{ marginRight: '5px' }}
          />
          <label style={{ marginRight: '10px', color: '#bdbdbd',textShadow: '2px 2px 4px #242424' }}>Нет услуг</label>
      </div> 

      <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={showHousesActiv}
            onChange={handleHousesActivChange}
            style={{ marginRight: '5px' }}
          />
          <label style={{ marginRight: '10px', color: '#bdbdbd',textShadow: '2px 2px 4px #242424' }}>Построен</label>
      </div>     
    </div>  
    )}
    </React.Fragment>
  );
}

export default PoligonsFilterConstructionViewing;